import SelectAgency from "pages/Payments/SelectAgency";
import SelectMDA from "pages/Payments/SelectMDA";
import SelectRegion from "pages/Payments/SelectRegion";
import React, { useMemo } from "react";
import { Row, Col, Label, Input, FormFeedback, FormGroup } from "reactstrap";
import Flatpickr from "react-flatpickr";
// import SelectEntity from "./SelectEntity";
import SelectPositionType from "pages/Payments/SelectPositionType";
import SelectSector from "pages/Payments/SelectSector";
import SelectFile from "./SelectFile";
import { useProfile } from "Components/Hooks/UserHooks";
import { isAllowed } from "common/lib/permissionUtils";

const OtherForm = ({ validation }: { validation: any }) => {
  const { userProfile } = useProfile();

  const canSelectAgency = useMemo(() => {
    return isAllowed(userProfile?.permissions, [
      {
        resource: "payment",
        action: "create",
      },
    ]);
  }, [userProfile?.permissions]);

  return (
    <>
      {/* <SelectRequestType validation={validation} /> */}
      <Row>
        <Col md={8} className="mb-3">
          <Label htmlFor="requestTitle" className="form-label">
            Request Title
          </Label>
          <Input
            name="requestTitle"
            id="requestTitle"
            className="form-control"
            placeholder="Enter request title"
            type="text"
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            value={validation.values.requestTitle || ""}
            invalid={
              validation.touched.requestTitle && validation.errors.requestTitle
            }
          />
          <FormFeedback>{validation.errors.requestTitle}</FormFeedback>
        </Col>
        <Col md={4} className="mb-3">
          <Label htmlFor="projectId" className="form-label">
            Project ID
          </Label>
          <Input
            name="projectId"
            id="projectId"
            className="form-control"
            placeholder="Enter project ID"
            type="text"
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            value={validation.values.projectId || ""}
            invalid={
              validation.touched.projectId && validation.errors.projectId
            }
          />
          <FormFeedback>{validation.errors.projectId}</FormFeedback>
        </Col>
        <Col md={4} className="mb-3">
          <SelectRegion validation={validation} />
        </Col>
        <Col md={4} className="mb-3">
          <SelectMDA validation={validation} />
        </Col>
        <Col md={4} className="mb-3">
          <SelectSector validation={validation} />
        </Col>
        {/* <Col md={3} className="mb-3">
          <SelectEntity validation={validation} />
        </Col> */}
        {canSelectAgency && (
          <Col md={4} className="mb-3">
            <SelectAgency validation={validation} />
          </Col>
        )}
        <Col md={4} className="mb-3">
          <Label htmlFor="dateOfRequest-field" className="form-label">
            Date of Request
          </Label>
          {/* @ts-ignore */}
          <Flatpickr
            name="dateOfRequest"
            id="dateOfRequest-field"
            className="form-control"
            placeholder="Select start date"
            options={{
              enableTime: false,
              altInput: false,
              altFormat: "d M, Y",
              dateFormat: "d M, Y",
            }}
            onChange={(e) => {
              validation.setFieldValue("dateOfRequest", e[0]);
            }}
            value={validation.values.dateOfRequest || ""}
          />
          {validation.touched.dateOfRequest &&
          validation.errors.dateOfRequest ? (
            <FormFeedback type="invalid">
              {validation.errors.dateOfRequest}
            </FormFeedback>
          ) : null}
        </Col>
        <Col md={4} className="mb-3">
          <Label htmlFor="totalValueOfRequest" className="form-label">
            Total Value of Request (USD)
          </Label>
          <Input
            type="number"
            name="totalValueOfRequest"
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            value={validation.values.totalValueOfRequest || ""}
            invalid={
              validation.touched.totalValueOfRequest &&
              validation.errors.totalValueOfRequest
            }
          />
          <FormFeedback>{validation.errors.totalValueOfRequest}</FormFeedback>
        </Col>
      </Row>

      <Row>
        <Col md={6} className="mb-4 mt-2 ms-1">
          <FormGroup switch className="form-switch-lg">
            <Input
              type="switch"
              name="isStaffRequest"
              checked={validation.values.isStaffRequest}
              onChange={validation.handleChange}
              value={validation.values.isStaffRequest}
            />
            <Label check>Is this a Staff Request?</Label>
          </FormGroup>
        </Col>
      </Row>
      {validation.values.isStaffRequest ? (
        <>
          <Row>
            <Col md={6} className="mb-3">
              <Label htmlFor="positionTitle" className="form-label">
                Position Title
              </Label>
              <Input
                name="positionTitle"
                id="positionTitle"
                className="form-control"
                placeholder="Enter position title"
                type="text"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.positionTitle || ""}
                invalid={
                  validation.touched.positionTitle &&
                  validation.errors.positionTitle
                }
              />
              <FormFeedback>{validation.errors.positionTitle}</FormFeedback>
            </Col>
            <Col md={3} className="mb-3">
              <Label htmlFor="noOfPositionsRequested" className="form-label">
                Number of Positions Requested
              </Label>
              <Input
                type="number"
                name="noOfPositionsRequested"
                placeholder="Enter number of positions requested"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.noOfPositionsRequested || ""}
                invalid={
                  validation.touched.noOfPositionsRequested &&
                  validation.errors.noOfPositionsRequested
                }
              />
              <FormFeedback>
                {validation.errors.noOfPositionsRequested}
              </FormFeedback>
            </Col>
            <Col md={3} className="mb-3">
              <SelectPositionType validation={validation} />
            </Col>

            <Col md={3} className="mb-3">
              <Label htmlFor="requestedSalary" className="form-label">
                Requested Salary
              </Label>
              <Input
                type="number"
                name="requestedSalary"
                placeholder="Enter requested salary"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.requestedSalary || ""}
                invalid={
                  validation.touched.requestedSalary &&
                  validation.errors.requestedSalary
                }
              />
              <FormFeedback>{validation.errors.requestedSalary}</FormFeedback>
            </Col>
            <Col md={3} className="mb-3">
              <Label htmlFor="periodInMonths" className="form-label">
                Period in Months
              </Label>
              <Input
                type="number"
                name="periodInMonths"
                placeholder="Enter period in months"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.periodInMonths || ""}
                invalid={
                  validation.touched.periodInMonths &&
                  validation.errors.periodInMonths
                }
              />
              <FormFeedback>{validation.errors.periodInMonths}</FormFeedback>
            </Col>
            <Col md={6} className="mb-3">
              <Label htmlFor="requestedSalary" className="form-label">
                Funding Status
              </Label>
              <select
                name="fundingStatus"
                id="fundingStatus"
                className="form-control"
                data-choices
                data-choices-search-false
                onChange={validation.handleChange}
                value={validation.values.fundingStatus}
              >
                <option value="">Select funding status</option>
                <option value={"In-progress"}>In-progress</option>
                <option value={"Pending"}>Pending</option>
                <option value={"Completed"}>Completed</option>
                <option value={"Denied"}>Denied</option>
              </select>
            </Col>
          </Row>

          <Row>
            <Col md={6} className="mb-3">
              <Label htmlFor="requestDescription" className="form-label">
                Review of Request
              </Label>
              <Input
                type="textarea"
                name="reviewOfRequest"
                id="reviewOfRequest"
                rows={4}
                placeholder="Enter review of request"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.reviewOfRequest || ""}
                invalid={
                  validation.touched.reviewOfRequest &&
                  validation.errors.reviewOfRequest
                }
              />
              <FormFeedback>{validation.errors.reviewOfRequest}</FormFeedback>
            </Col>
            <Col md={6} className="mb-3">
              <Label htmlFor="requestDescription" className="form-label">
                Additional Details
              </Label>
              <Input
                type="textarea"
                name="additionalDetails"
                id="additionalDetails"
                rows={4}
                placeholder="Enter additional details"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.additionalDetails || ""}
                invalid={
                  validation.touched.additionalDetails &&
                  validation.errors.additionalDetails
                }
              />
              <FormFeedback>{validation.errors.additionalDetails}</FormFeedback>
            </Col>
          </Row>
        </>
      ) : (
        <Row>
          <Col md={6} className="mb-3">
            <Label htmlFor="requestDescription" className="form-label">
              Request Description
            </Label>
            <Input
              type="textarea"
              name="requestDescription"
              id="requestDescription"
              rows={4}
              placeholder="Enter request description"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.requestDescription || ""}
              invalid={
                validation.touched.requestDescription &&
                validation.errors.requestDescription
              }
            />
            <FormFeedback>{validation.errors.requestDescription}</FormFeedback>
          </Col>
          <Col md={6} className="mb-3">
            <Label htmlFor="requestDescription" className="form-label">
              Additional Details
            </Label>
            <Input
              type="textarea"
              name="additionalDetails"
              id="additionalDetails"
              rows={4}
              placeholder="Enter additional details"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.additionalDetails || ""}
              invalid={
                validation.touched.additionalDetails &&
                validation.errors.additionalDetails
              }
            />
            <FormFeedback>{validation.errors.additionalDetails}</FormFeedback>
          </Col>
        </Row>
      )}

      <Row>
        <Col md={12} className="mb-3">
          <SelectFile validation={validation} />
        </Col>
      </Row>
    </>
  );
};

export default OtherForm;
